import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { CmsFacet, ConvertedComponentData, FsCatalog, TextInput } from '../../../types'
import {
  CmsConverterService,
  defaultFSCatalog,
  defaultTextInput
} from '../../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class ProductFinderStepConverter extends CmsConverterService<ProductFinderStepData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      items: formData.st_content ?? defaultFSCatalog,
      stepName: formData.st_step_text ?? defaultTextInput,
      headline: formData.st_headline ?? defaultTextInput,
      subText: formData.st_subText ?? defaultTextInput
    }
  }
}

export const PRODUCT_FINDER_STEP_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, ProductFinderStepData>>('ProductFinderStepConverter')

export interface ProductFinderStepData extends ConvertedComponentData {
  items: FsCatalog<{ facet: CmsFacet, items?: FsCatalog }>;
  stepName: TextInput;
  headline: TextInput;
  subText: TextInput;
}
